import * as hooks from '@wordpress/hooks';
import AffiliationItem from './components/AffiliationItem';
import Buttons from './components/Buttons';
import PostsGrid from './components/PostsGrid';
import LocationDetails from './components/LocationDetails';
import SplashHero from './components/SplashHero';
const { addFilter } = hooks;

interface Filters {
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	[key: string]: any;
}

const filters: Filters = {
	'component.LocationDetails': LocationDetails,
	'component.SplashHero': SplashHero,
	'directory.Buttons': Buttons,
	'directory.PostsGrid': PostsGrid,
	'component.AffiliationItem': AffiliationItem,
	'data.allowedCountries': 'US',
	'data.filter-locations-available-radiuses': [10, 25, 50, 100],
};

for (const hook in filters) {
	addFilter(hook, 'vib', () => filters[hook], 1);
}

window.findaWpHooks = hooks;
